import { useRoutes } from 'react-router-dom';

import { usePublicAuthUrls } from './routing/usePublicAuthUrls';
import { getPublicAuthModuleRoutes } from './routes';

export const PublicAuthRoutesWrapper = () => {
  const { loginPageUrl } = usePublicAuthUrls();
  const routes = getPublicAuthModuleRoutes({
    defaultRedirectPath: loginPageUrl,
  });
  return useRoutes(routes);
};
